import React from "react";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { completeReview, CLAIMED_FOR_REVIEW, DISAGREED, CLAIMED_FOR_FORWARD_REVIEW } from "../../../portal";
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import { useExpertMessageContext } from "../expert-message/ExpertMessageContext";
export const INITIAL_REVIEW_STATE = {
  dialogues: {},
  escalation: {},
  pristine: true
};
export const useMessageReview = () => {
  const log = pilog.getLogger("useMessageReview");
  const [messageReviewDetails, setMessageReviewDetails] = React.useState(INITIAL_REVIEW_STATE);
  const {
    addFailureNotification
  } = useNotificationContext();
  const messageContext = useExpertMessageContext();
  log.debug(messageReviewDetails);
  const {
    message,
    changeMessageState,
    clearMessageAndUnclaim
  } = messageContext;

  //if the messageId changes, reset the message flag context
  React.useEffect(() => {
    setMessageReviewDetails(INITIAL_REVIEW_STATE);
  }, [messageContext.message.messageId]);
  React.useEffect(() => {
    //if this was a disagree and the expert touches the message (adds dialogue or CC, then send the disagree data)
    if (messageContext.message.hasExpertTouched && Object.keys(messageReviewDetails.escalation).length !== 0) {
      submitReviewData(true);
    }
  }, [messageContext.message.hasExpertTouched]);
  const updateDialogueVote = (dialogueId, isAdd) => {
    const newDialogues = {
      ...messageReviewDetails.dialogues
    };
    if (isAdd) {
      newDialogues[dialogueId] = "positive";
    } else {
      Reflect.deleteProperty(newDialogues, dialogueId);
    }
    setMessageReviewDetails({
      ...messageReviewDetails,
      dialogues: newDialogues,
      pristine: false
    });
  };
  const updateEscalationVote = (dialogueId, isAdd) => {
    const newEscalations = {
      ...messageReviewDetails.escalation
    };
    newEscalations[dialogueId] = isAdd ? "agree" : "disagree";
    if (!isAdd) {
      switchToDisagree();
    } else {
      switchBackToForwardReview();
    }
    setMessageReviewDetails({
      ...messageReviewDetails,
      escalation: newEscalations,
      pristine: false
    });
  };
  const submitReviewData = (silent = false) => {
    completeReview(message, messageReviewDetails, response => {
      if (response.hasError) {
        addFailureNotification("Failed to submit review data");
      } else if (!silent) {
        //no error, hurray, changed to reviewed
        //removeFromInbox unclaim
        clearMessageAndUnclaim();
      }
    });
  };
  const switchToDisagree = () => {
    changeMessageState(DISAGREED);
  };
  const switchToReview = () => {
    changeMessageState(CLAIMED_FOR_REVIEW);
  };
  const switchBackToForwardReview = () => {
    if (message.conversationState.state === DISAGREED) {
      changeMessageState(CLAIMED_FOR_FORWARD_REVIEW);
    }
  };
  const resetReviewState = () => {
    setMessageReviewDetails(INITIAL_REVIEW_STATE);
    changeMessageState(CLAIMED_FOR_FORWARD_REVIEW);
  };

  // Make the context object:
  return {
    message,
    messageReviewDetails,
    updateDialogueVote,
    updateEscalationVote,
    submitReviewData,
    switchToReview,
    resetReviewState
  };
};